import { RouterProvider } from 'react-router';
import { router } from './routes';
import { useEffect } from 'react';
import { SettingsProvider } from './contexts/SettingsContext';
import { PropertyProvider } from './contexts/PropertyContext';
import { CategoriesProvider } from './contexts/CategoriesContext';
import { FacilitiesProvider } from './contexts/FacilitiesContext';
import { Toaster } from './components/ui/sonner';

function App() {
  useEffect(() => {
    // Set RTL direction and language
    document.documentElement.dir = 'rtl';
    document.documentElement.lang = 'ar';
    document.body.style.fontFamily = "'Cairo', sans-serif";
  }, []);

  return (
    <FacilitiesProvider>
      <CategoriesProvider>
        <PropertyProvider>
          <SettingsProvider>
            <RouterProvider router={router} />
            <Toaster position="top-center" dir="rtl" />
          </SettingsProvider>
        </PropertyProvider>
      </CategoriesProvider>
    </FacilitiesProvider>
  );
}

export default App;